const CONFIG = process.env.REACT_APP_CONFIG

let URL = ""
if (CONFIG === "dev") {
  URL = "http://127.0.0.1:5000"
}
else {
  URL = process.env.REACT_APP_BE_URL
}

export const BASE_URL = URL;
export const REDIRECT_URI = URL;
